import { Observable, of, from} from 'rxjs';
import { catchError, switchMap, map} from 'rxjs/operators';
import { ofType } from 'redux-observable';
import LoginService from '../services/login.service';
import {
  RestorePassword,
  RestorePasswordAction,
  RestorePasswordActions,
  RestorePasswordError,
  RestorePasswordSuccess,
} from '../actions/restore.action';



const restoreEpic = (action$: Observable<RestorePasswordAction>) => action$.pipe(
  ofType<RestorePassword>(RestorePasswordActions.RestorePassword),
  switchMap((action) => from(LoginService.restore(action.apiOptions)).pipe(
    map(() =>
      new RestorePasswordSuccess(),
    ),
    catchError((error) => (
      of(
        new RestorePasswordError(error?.message)
      )
    )),
  )),
);

const RestoreEpics = [
  restoreEpic,
];

export default RestoreEpics;
